import { Container, createStyles, Loader, Text } from "@mantine/core";

export const FullPageLoader = ({ label = "Loading" }) => {
  const { classes } = useStyles();

  return (
    <Container className={classes.loadingContainer}>
      <div className={classes.loadingSpinnerWrapper}>
        <Loader />
        <Text size="sm">{label}</Text>
      </div>
    </Container>
  );
};

const useStyles = createStyles(() => ({
  loadingContainer: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center"
  },

  loadingSpinnerWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",

    span: {
      fontSize: "14px"
    }
  }
}));
